module.exports = __webpack_public_path__ + "static/yelp-f72ae75a7fe98b0b5e78f74129e3426d.png";